import { useMemo } from 'react';
import styled from 'styled-components';
import { marginTopBottomMixin } from '../../mixins.js';

const InvisibleSelector = /*#__PURE__*/styled.input.attrs(_ref => {
  let {
    type
  } = _ref;
  return {
    type
  };
}).withConfig({
  displayName: "base__InvisibleSelector",
  componentId: "zettle__sc-i4175n-0"
})(["position:absolute;height:1px;min-height:1px;width:0px;max-height:1px;max-width:0px;margin:0px;padding:0px;opacity:0 !important;appearance:none;"]);
const getCursor = _ref2 => {
  let {
    disabled,
    loading
  } = _ref2;
  if (loading) {
    return "wait";
  } else if (disabled) {
    return "not-allowed";
  } else {
    return "pointer";
  }
};
const ControlContainer = /*#__PURE__*/styled.label.withConfig({
  displayName: "base__ControlContainer",
  componentId: "zettle__sc-i4175n-1"
})(["line-height:0;", " z-index:1;position:relative;display:inline-flex;align-items:flex-start;cursor:", ";-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;"], marginTopBottomMixin({
  top: "none",
  bottom: "small"
}), getCursor);
const DecorativeContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "base__DecorativeContainer",
  componentId: "zettle__sc-i4175n-2"
})(["line-height:0;display:inline-block;"]);
let SelectorStateClassnames = /*#__PURE__*/function (SelectorStateClassnames) {
  SelectorStateClassnames["HOVER"] = "selector--hover";
  SelectorStateClassnames["ACTIVE"] = "selector--active";
  return SelectorStateClassnames;
}({});
const selectorStates = {
  checked: `${InvisibleSelector}:checked ~ &`,
  indeterminate: `${InvisibleSelector}:indeterminate ~ &`,
  invalid: `${InvisibleSelector}[aria-invalid="true"] ~ &`,
  invalidChecked: `${InvisibleSelector}[aria-invalid="true"]:checked ~ &`,
  invalidIndeterminate: `${InvisibleSelector}[aria-invalid="true"]:indeterminate ~ &`,
  disabled: `${InvisibleSelector}:disabled ~ &`,
  disabledChecked: `${InvisibleSelector}:disabled:checked ~ &`,
  disabledIndeterminate: `${InvisibleSelector}:disabled:indeterminate ~ &`,
  focus: `${InvisibleSelector}:not(.no-focus):focus ~ &`,
  hover: `${ControlContainer}:hover &, .${SelectorStateClassnames.HOVER}:hover &`,
  active: `${ControlContainer}:active &, .${SelectorStateClassnames.ACTIVE}:active &`
};

/**
 * Avoid focus styles on an element by setting a no-focus class onClick,
 * which is reset when the element is blurred.
 * */
const useFocusHandling = (ref, setNoFocus, onBlur) => useMemo(() => {
  const handleClick = e => {
    e.stopPropagation();
    if (ref.current) {
      ref.current.focus();
    }
    const target = e.target;
    if (target.tagName !== "INPUT") {
      setNoFocus(true);
    }
  };
  const handleBlur = e => {
    if (onBlur) {
      onBlur(e);
    }
    setNoFocus(false);
  };
  return {
    handleClick,
    handleBlur
  };
}, [onBlur, ref, setNoFocus]);

export { ControlContainer, DecorativeContainer, InvisibleSelector, SelectorStateClassnames, selectorStates, useFocusHandling };
//# sourceMappingURL=base.js.map
